import { IZCoreAIChatUser } from '../types';
import { EntityService } from './EntityService';

export class ZCoreAIChatUserService extends EntityService<IZCoreAIChatUser> {
    constructor() {
        super(`/ZCoreAIChatUsers`);
    }
}